import { Button, Modal } from 'react-bootstrap';
import Timer from './timer';

const IdleModal = ({ show, onClick }) => {
  return (
    <Modal show={show} aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          User Inactive
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your session is about to expire due to inactivity. To avoid, please
          click on <b>Continue</b> button.
        </p>
        {show ? <Timer /> : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' size='sm' onClick={onClick}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IdleModal;
